import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { getPendingCompanies } from 'services/clients.svc'

import './PendingCompanies.scss'

export default function PendingCompanies() {
  const navigate = useNavigate()
  
  const { data: companies, isLoading } = useQuery(
    ['pending-companies'],
    getPendingCompanies
  )

  if (isLoading) {
    return <div aria-busy="true">Loading...</div>
  }

  return (
    <div className="pending-companies-container">
      <div className="page-header">
        <h1>Pending Company Registrations</h1>
        <p>Review and approve new company registrations</p>
      </div>
      
      {companies?.length === 0 ? (
        <div className="empty-state">
          <h3>No Pending Registrations</h3>
          <p>All company registrations have been processed.</p>
        </div>
      ) : (
        <div className="companies-table-container">
          <table className="companies-table">
            <thead>
              <tr>
                <th>Company Name</th>
                <th>ABN</th>
                <th>Builder Registration</th>
                <th>Contact Email</th>
                <th>Submitted Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {companies?.map((company) => (
                <tr key={company._id}>
                  <td>
                    <div className="company-name">
                      {company.image && (
                        <img src={company.image.url} alt="Company logo" className="company-logo-small" />
                      )}
                      <span>{company.name}</span>
                    </div>
                  </td>
                  <td>{company.abn}</td>
                  <td>{company.buildersRegNumber}</td>
                  <td>{company.email}</td>
                  <td>{company.createdAt ? new Date(company.createdAt).toLocaleString() : '—'}</td>
                  <td>
                    <button 
                      onClick={() => navigate(`/clients/pending/${company._id}`)}
                      className="review-button"
                    >
                      Review
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}